import {O} from "web-vcore";
import {Entity, EntryVisibility} from "../../Server/DB/entities/@Entity.js";
import {CreateAccessor} from "mobx-graphlink";
import {GetStories, GetStory} from "../../Server/DB/stories.js";
import {MeID} from "../../Server/DB/users.js";

export class ContentState {
	@O accessor subpage = "scenes";

	@O accessor entities = new EntitiesState();

	// stories page
	@O accessor selectedStory: string|n;
	@O accessor hideSummarizedMessages = true;
	@O accessor hideSummaryMessages_enabled = true;
	@O accessor hideSummaryMessages_keepLastX = 2;
	@O accessor hideOffChainNormalMessages_enabled = true;
	@O accessor hideOffChainNormalMessages_keepLastX = 2;
	@O accessor messageFilter = "";
	@O accessor mark_1: string|n;
	@O accessor mark_2: string|n;
	@O accessor summarize_responseTokens = 20000;
}

export class EntitiesState {
	@O accessor entityPool = EntityPool.online;
	@O accessor filter = "";
	@O accessor lastEntityVisibility = EntryVisibility.public;

	@O accessor entities_local: Entity[] = [];
}

export enum EntityPool {
	online = "online",
	local = "local",
}

export const GetSelectedStoryID = CreateAccessor({ctx: 1}, function() {
	return this.store.main.content.selectedStory;
});
export const GetSelectedStory = CreateAccessor(()=>{
	const selectedID = GetSelectedStoryID();

	//return GetStory(selectedID);
	// do it this way instead (for now), so there isn't a db-wait each time the selection changes
	const stories = GetStories(MeID());
	return stories.find(a=>a.id == selectedID);
});